import './Automotriz.css';
import React from "react";
import { Link } from "react-router-dom";
import Automotriz1 from '../../assets/Productos/Automotriz/Automotriz1.png';
import Automotriz2 from '../../assets/Productos/Automotriz/Automotriz2.png';
import Automotriz3 from '../../assets/Productos/Automotriz/Automotriz3.png';


const images = [
    { src: Automotriz1, text: "MF203 Sellador de parabrisas de poliuretano", id: 35 },
    { src: Automotriz2, text: "MF212 Sellador climático de silicona", id: 36 },
    { src: Automotriz3, text: "MF892 Sellador automotriz de silicona", id: 37 },
];

function Automotriz() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <Link to={`/productos/${item.id}`}>
                            <img src={item.src} alt={item.text} />
                        </Link>
                        <p>{item.text}</p> {/* Nombre del producto sin enlace */}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Automotriz;
